import { RPCs } from "../../services/rpc.js";
import { DateTime as DateTime$1 } from "../../components/DateTime/index.js";
import { useRPC } from "../../hooks/useRPC/index.js";
import { EditButton } from "../../components/Buttons/index.js";
import { REFS_LINK_TYPE_LABELS_MAP } from "./RefsByTypeTitles/constants.js";
import { RefLinkRefCard } from "./RefLinkRefCard.js";
import { UserNameWithAvatar } from "../Users/shared/UserNameWithAvatar.js";
import { Fragment } from "react";
import { Icon, Label, Loading, Modal } from "@therms/atalaya";
import { IoLink } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/RefLinkDetailModal.tsx
function RefLinkDetailModal({ closeHandler, forRef, onClickEdit, refLinkId }) {
	const { data, isCalling } = useRPC(RPCs.RefLinks.GetRefLink.v1, { id: refLinkId });
	return /* @__PURE__ */ jsxs(Modal, {
		closeHandler,
		escPressClose: true,
		header: /* @__PURE__ */ jsxs("div", {
			className: "flex w-full justify-between",
			children: [/* @__PURE__ */ jsx("span", {
				className: "text-color-subtle text-lg leading-6 font-medium",
				children: "Ref Link"
			}), onClickEdit && (forRef?.value === data?.controller.value || forRef?.value === data?.controller?.redirectRef?.value) && /* @__PURE__ */ jsx(EditButton, { onClick: onClickEdit })]
		}),
		children: [
			isCalling && !data && /* @__PURE__ */ jsx(Loading, { overlay: true }),
			data?.reason && /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ jsx(Label, { children: "Reason" }), /* @__PURE__ */ jsx("p", { children: data?.reason })]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "mt-base space-y-xxs flex flex-col",
				children: [
					/* @__PURE__ */ jsx(Label, { children: "Linked" }),
					data?.linkedByUserId && /* @__PURE__ */ jsx(UserNameWithAvatar, { userId: data?.linkedByUserId }),
					/* @__PURE__ */ jsx(DateTime$1, { timestamp: data?.linkedAt })
				]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "mt-base",
				children: /* @__PURE__ */ jsx(Label, { children: "Refs" })
			}),
			forRef?.value !== data?.controller.value && forRef?.value !== data?.controller?.redirectRef?.value && /* @__PURE__ */ jsxs("div", {
				className: "gap-xs text-color-subtle pb-xs flex items-center text-sm",
				children: [/* @__PURE__ */ jsx("span", { children: "To Edit Refs, go to the original Ref Link" }), /* @__PURE__ */ jsx(Icon, {
					color: "info",
					Icon: IoLink,
					size: "sm"
				})]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "grid w-full grid-cols-[auto_auto_minmax(0,1fr)] gap-4",
				children: data?.refs.map((ref) => /* @__PURE__ */ jsxs(Fragment, { children: [
					/* @__PURE__ */ jsx("div", {
						className: "text-color-subtle flex items-center",
						children: /* @__PURE__ */ jsx(Icon, {
							color: ref.value === data.controller.value || ref.value === data.controller?.redirectRef?.value ? "info" : "subtle",
							Icon: IoLink
						})
					}),
					/* @__PURE__ */ jsx("div", {
						className: "flex items-center",
						children: REFS_LINK_TYPE_LABELS_MAP[ref.type].single
					}),
					/* @__PURE__ */ jsx("div", {
						className: "flex-1",
						children: /* @__PURE__ */ jsx(RefLinkRefCard, {
							type: ref.type,
							value: ref.value
						})
					})
				] }, ref.value))
			})
		]
	});
}
//#endregion
export { RefLinkDetailModal };

//# sourceMappingURL=RefLinkDetailModal.js.map